import { render, staticRenderFns } from "./EducationEntryAwardFocus.vue?vue&type=template&id=a7a4fd1c"
import script from "./EducationEntryAwardFocus.vue?vue&type=script&lang=js"
export * from "./EducationEntryAwardFocus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports